import React, { useState, useEffect, useRef } from "react"
import classNames from "classnames"
import styles from "./OtherPlatformSubscription.module.scss"
import Monthly from "./Monthly/Monthly"
import Yearly from "./Yearly/Yearly"

const OtherPlatformSubscription = () => {
  const tabs = ["Monthly", "Yearly"]
  const [activeTab, setActiveTab] = useState(tabs[0])
  const [indicatorStyle, setIndicatorStyle] = useState({})
  const tabsRef = useRef([])

  useEffect(() => {
    const activeTabIndex = tabs.indexOf(activeTab)

    if (tabsRef.current[activeTabIndex]) {
      const activeTabElement = tabsRef.current[activeTabIndex]
      setIndicatorStyle({
        width: `${activeTabElement.offsetWidth}px`,
        transform: `translateX(${activeTabElement.offsetLeft}px)`,
      })
    }
  }, [activeTab])

  return (
    <div className="bg-white p-3 mt-3 rounded">
      <div className={styles.tabsContainer}>
        <div className={styles.tabsWrapper}>
          {tabs.map((tab, index) => (
            <div
              key={index}
              ref={(el) => (tabsRef.current[index] = el)}
              className={classNames(styles.tab, {
                [styles.activeTab]: activeTab === tab,
              })}
              onClick={() => setActiveTab(tab)}
            >
              {tab} {tab === "Yearly" && <span>-20% off</span>}
            </div>
          ))}
          <div className={styles.indicator} style={indicatorStyle} />
        </div>
      </div>

      {activeTab === "Monthly" && <Monthly />}
      {activeTab === "Yearly" && <Yearly />}
    </div>
  )
}

export default OtherPlatformSubscription
